import { Controller } from "@hotwired/stimulus";
import bootstrap from "bootstrap/dist/js/bootstrap";

export default class extends Controller {
  static targets = ["partialToUpdate", "modal"];
  static values = {
    tableId: String,
    resourceName: String,
  };

  connect() {
    this.initializeDataTable();
  }

  updateHtml(event) {
    const [_data, _status, xhr] = event.detail;
    this.partialToUpdateTarget.innerHTML = xhr.response;
  }

  getTableId() {
    return this.hasTableIdValue
      ? this.tableIdValue
      : `${this.resourceNameValue}Table`;
  }

  initializeDataTable() {
    const tableId = this.getTableId();
    const table = document.getElementById(tableId);

    if (!table) {
      console.warn(`Table with ID '${tableId}' not found.`);
      return;
    }

    try {
      this.destroyExistingDataTable(tableId);

      const config = {
        paging: this.getBooleanAttribute(table, "data-paging", true),
        searching: this.getBooleanAttribute(table, "data-searching", true),
        ordering: this.getBooleanAttribute(table, "data-ordering", true),
        info: this.getBooleanAttribute(table, "data-info", true),
        stateSave: this.getBooleanAttribute(table, "data-state-save", false),
      };

      const sortColumn = table.hasAttribute("data-sort-column")
        ? parseInt(table.dataset.sortColumn, 10)
        : 0;
      const sortDirection = table.hasAttribute("data-sort-direction")
        ? table.dataset.sortDirection
        : "desc";

      if (config.ordering) {
        config.order = [[sortColumn, sortDirection]];
      } else {
        config.order = [];
      }

      $(`#${tableId}`).DataTable(config);
    } catch (error) {
      console.error(`Error initializing DataTable: ${error.message}`);
    }
  }

  getBooleanAttribute(element, attribute, defaultValue) {
    return element.hasAttribute(attribute)
      ? element.getAttribute(attribute) === "true"
      : defaultValue;
  }

  destroyExistingDataTable(tableId) {
    if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
      $(`#${tableId}`).DataTable().destroy();
    }
  }

  openModal(event) {
    const modal = bootstrap.Modal.getOrCreateInstance(this.modalTarget);

    if (modal) {
      modal.show();
    }
    this.updateHtml(event);
  }

  closeModal() {
    const modal = bootstrap.Modal.getInstance(this.modalTarget);
    if (modal) {
      modal.hide();
    }
  }

  processResponseRow(responseHtml) {
    const tempTable = document.createElement("table");
    tempTable.innerHTML = responseHtml;
    return tempTable.querySelector("tr");
  }

  updateTable(event) {
    const [_data, _status, xhr] = event.detail;
    const newRow = this.processResponseRow(xhr.response);
    if (!newRow) return;

    const rowId = newRow.id;
    const existingRow = document.getElementById(rowId);
    const tableId = this.getTableId();

    try {
      this.destroyExistingDataTable(tableId);

      if (existingRow) {
        existingRow.innerHTML = newRow.innerHTML;
      } else {
        const tableBody = document.querySelector(`#${tableId} tbody`);
        if (tableBody) {
          tableBody.insertBefore(newRow, tableBody.firstChild);
          this.updateCountBadge(1);
        }
      }

      this.initializeDataTable();
    } catch (error) {
      console.error("Error updating table:", error);
      if (existingRow) {
        existingRow.outerHTML = newRow.outerHTML;
      } else {
        const tableBody = document.querySelector(`#${tableId} tbody`);
        if (tableBody) {
          tableBody.insertBefore(newRow, tableBody.firstChild);
        }
      }
    }

    this.closeModal();
  }

  appendRow(event) {
    const [_data, _status, xhr] = event.detail;
    const newRow = this.processResponseRow(xhr.response);
    const tableId = this.getTableId();
    const tableBody = document.querySelector(`#${tableId} tbody`);

    try {
      this.destroyExistingDataTable(tableId);
      tableBody.insertBefore(newRow, tableBody.firstElementChild);
      this.updateCountBadge(1);
      this.initializeDataTable();
    } catch (error) {
      console.error("Error appending row:", error);
      tableBody.insertBefore(newRow, tableBody.firstElementChild);
    }

    this.closeModal();
  }

  updateCountBadge(change) {
    const countBadge = document.querySelector(".badge.bg-primary.rounded-pill");
    if (countBadge) {
      const currentCount = parseInt(countBadge.textContent.trim());
      if (!isNaN(currentCount)) {
        countBadge.textContent = (currentCount + change).toString();
      }
    }
  }
}
